<template>
	<div class="filmOrder">
		<!-- @click-left="checkToBack" -->
		<van-nav-bar title="确认订单" left-arrow @click-left="$router.back()">
		</van-nav-bar>
		<!-- <div @click="checkToBack">返回</div> -->
		<div class="fenge"></div>
		<!-- 手机号 -->
		<div
			style="
				display: flex;
				align-items: center;
				padding: 10px;
				background-color: #fff;
				margin-bottom: 10px;
			"
		>
			<div>
				<van-icon color="#bdc0c5" name="manager-o" size="20" />
			</div>
			<div>
				<div style="font-size: 14px">
					<van-field v-model="mobile" @blur="mobileBlur" type="tel" />
				</div>
				<div style="color: #a77924; padding-left: 0.42rem; font-size: 12px">
					订单信息将发送到该手机
				</div>
			</div>
		</div>
		<!-- 电影信息 -->
		<div style="background-color: #fff; margin-bottom: 10px">
			<div
				style="
					display: flex;
					align-items: center;
					border-bottom: 1px solid #f8f8f8;
					padding: 10px;
				"
			>
				<div>
					<img :src="movieItem.pic" class="img" />
				</div>
				<div style="margin-left: 10px">
					<div style="font-size: 16px; margin-bottom: 4px">
						{{ movieItem.film_name }}
						<!-- <span v-if="movieItem.showmark">({{ movieItem.showmark }})</span> -->
					</div>
					<div style="color: #797d82; margin-bottom: 4px">
						{{ movieItem.show_time }}
					</div>
					<div style="color: #797d82; margin-bottom: 4px">
						{{ movieItem.cinemainfo.cinema_name }}
					</div>
					<div style="color: #797d82; margin-bottom: 4px">
						{{ movieItem.hall_name }}
					</div>
					<div style="color: #797d82; margin-bottom: 4px">
						{{ movieItem.seatInfo }}
					</div>
				</div>
			</div>
			<van-cell style="margin-bottom: 10px" title="商品金额">
				<template #label>
					<div>
						<div>该电影不支持退换票</div>
					</div>
				</template>
				<template #right-icon>
					<div style="color: #c03159">
						<span style="margin-right: 10px">
							<span class="fs-12">{{
								Math.round(movieItem.totalPrice * 100) / 100
							}}</span>
							<span>{{ mallInfo.couponUnit }} </span>
						</span>
						<!-- -->
						<span
							v-if="
								userInfo.tenantId == '025227' &&
								movieItem.settlePrice &&
								movieItem.settlePrice * 1 > movieItem.showPrice * 1
							"
							class="fs-10 settle-active"
							>{{ movieItem.settlePrice
							}}<span>{{ mallInfo.couponUnit }} </span>
						</span>
					</div>
				</template>
			</van-cell>
		</div>
		<van-cell
			style="margin-bottom: 10px"
			icon="gift-o"
			:title="mallInfo.couponName"
			@click="toCheckCard"
			is-link
		>
			<template #right-icon>
				<div style="display: flex; align-items: center">
					<!-- {{ cardids ? "-  " + deduct + couponUnit : "请选择卡券" }} -->
					<span v-if="useCard.cardCount >= 0">{{
						cardids ? "已抵扣" + useCard.cardCount + "张" : "请选择卡券"
					}}</span>
					<span v-else>{{
						cardids
							? "已抵扣" + useCard.cardPay + mallInfo.couponUnit
							: "请选择卡券"
					}}</span>

					<van-icon name="arrow" />
				</div>
			</template>
		</van-cell>
		<!-- <div
			style="
				padding: 20px;
				background-color: #fff;
				color: #797d82;
				font-size: 12px;
			"
		>
			<div>注意事项:</div>
			<div style="margin-bottom: 6px; color: red">
				1. 请在5分钟内完成支付,超时系统将释放您选定的座位
			</div>
			<div style="margin-bottom: 6px; color: red">
				2. 如订单未成功出票,我们将通过短信和订单页面进行提示,请您留意
			</div>
			<div style="margin-bottom: 6px">
				3. 请确认场次及订单号码等信息无误，购买成功后将不予退换
			</div>
			<div style="margin-bottom: 6px">
				4. 预计出票时间：下单成功后60分钟内出票，遇忙时可能会延时。
			</div>
			<div
				style="font-weight: 600; color: #000"
				v-if="movieItem.auto_check_seat === 1"
			>
				5. 所选座位被占时,自动调座到附近
			</div>
		</div> -->
		<div class="gpxz">
			<div class="title">购票须知</div>

			<div class="p">1、请确认场次和时间无误,退票和改签规则以订单提示为准;</div>
			<div class="p">
				2、由于设备故障等不可抗力因素,存在少量场次取消的情况网票福多多将及时进行退票退款,支付金额将原路退还;
			</div>
			<div class="p">
				3、由于影院系统不稳定等原因,可能存在出票失败的情况,网票福多多将及时进行退票退款,支付金额将原路退还;
			</div>
			<div class="p">
				4、订单支付并出票成功后,验票信息请在“我的-全部订单-订单详情”中查看
			</div>
		</div>
		<!-- 付款 -->
		<div class="sub-btn">
			<div style="font-size: 15px; display: flex; align-items: center">
				<span>实付</span>
				<!-- <span style="margin: 0 10px; color: #c03131"
					>{{ realMoney !== "" ? realMoney : price * orderInfo.quantity
					}}{{ couponUnit }}
				</span> -->
				<span style="margin: 0 10px; color: #c03131">
					{{
						useCard != ""
							? Math.round(useCard.wxPay * 100) / 100
							: Math.round(movieItem.totalPrice * 100) / 100
					}}
					{{ mallInfo.couponUnit }}
				</span>
				<van-button
					v-if="
						(this.mallInfo.casepay &&
							this.mallInfo.casepay != 1 &&
							useCard &&
							Math.round(useCard.wxPay * 100) / 100 > 0) ||
						(this.mallInfo.casepay && this.mallInfo.casepay != 1 && !useCard)
					"
					style="width: 100px"
					@click="checkuseCard"
					type="danger"
					color="#a0a3a8"
					:loading="subLoading"
					>支付</van-button
				>
				<van-button
					v-else
					style="width: 100px"
					@click="checkuseCard"
					type="danger"
					:loading="subLoading"
					>支付</van-button
				>
			</div>
		</div>
		<van-overlay :show="overlayShow">
			<div
				style="
					display: flex;
					align-items: center;
					justify-content: center;
					height: 100vh;
					width: 100vw;
				"
			>
				<div style="color: #fff">支付中,请稍等......</div>
			</div>
		</van-overlay>
		<!-- 是否选择卡券提醒 -->
		<van-dialog
			v-model="cardWarnShow"
			show-cancel-button
			show-confirm-button
			confirm-button-text="选择卡券"
			cancel-button-text="立即支付"
			@confirm="toCheckCard"
			@cancel="toSubmit"
		>
			<div style="padding: 50px 20px">您有卡券未使用,是否直接支付?</div>
		</van-dialog>
		<!-- 确认下单提示 -->
		<van-dialog
			v-model="payWarningShow"
			show-confirm-button
			show-cancel-button
			confirm-button-text="我知道了"
			cancel-button-text="取消"
			@confirm="checkPassword"
			@cancel="payWarningShow = false"
		>
			<div style="padding: 50px 20px">
				提示:影票一旦出售,将不支持退换!购票成功将发送短信通知,
				部分影院不提供3D眼镜,请以现场为准.
			</div>
		</van-dialog>
		<van-popup
			v-model="passwordShow"
			position="bottom"
			:style="{ height: '100%' }"
		>
			<CheckPassWord @passwordBackClick="passwordBackClick"></CheckPassWord>
		</van-popup>
	</div>
	<!--  -->
</template>

<script>
import { pay, cardUse, cardList } from "@/utils/api.js";
import { mapActions, mapGetters } from "vuex";
import CheckPassWord from "./components/checkPassWord.vue";
export default {
	components: { CheckPassWord },
	data() {
		return {
			passwordShow: false,
			passwordFlag: false,
			mobile: "",
			oldMobile: "",
			payWarningShow: false,
			subLoading: false,
			cardCount: "",
			couponUnit: "",
			couponName: "",
			outTradeNo: "",
			unpayId: "",
			mallInfo: {},
			userInfo: {},
			orderInfo: "",
			price: "",
			times: 900000,
			deductMoney: 0, //可抵扣的钱
			realMoney: "",
			cardids: "",
			deduct: "",
			useCard: "",
			productType: 0,
			cardCounts: "",
			overlayShow: false,
			cardWarnShow: false,
			cardlists: [],
			movieItem: {},
			stopData: "",
		};
	},
	computed: {
		...mapGetters(["currentCityCode"]),
	},
	mounted() {
		window.alert = function (name) {
			var iframe = document.createElement("IFRAME");
			iframe.style.display = "none";
			iframe.setAttribute("src", "data:text/plain,");
			document.documentElement.appendChild(iframe);
			window.frames[0].window.alert(name);
			iframe.parentNode.removeChild(iframe);
		};
	},
	created() {
		window.top.seatData = "";
		this.mallInfo = JSON.parse(window.localStorage.getItem("mallInfo"));
		this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
		this.mobile = this.userInfo.mobile;
		if (JSON.parse(localStorage.getItem("movieItem"))) {
			this.movieItem = JSON.parse(localStorage.getItem("movieItem"));
		} else {
			this.$router.push("/index");
		}

		this.cardWarnShow = false;
		this.getCard();
		this.getPrice();
	},
	methods: {
		mobileBlur() {
			localStorage.setItem("userMobile", this.mobile);
		},
		// 获取卡券并计算抵扣金额
		async getPrice() {
			let arr = JSON.parse(localStorage.getItem("lsData4"));
			console.log(arr);
			localStorage.removeItem("lsData4");
			this.cardids = window.localStorage.getItem("cardIds");
			localStorage.removeItem("cardIds");
			let money = 0;

			if (arr) {
				this.productType = arr[0].productType === 1 ? 1 : 0;
				let arr2 = [];
				arr.forEach((item) => {
					if (item.cardCounts) {
						arr2.push(item.cardCounts);
					}
				});
				this.cardCounts = arr2.join();
				const res = await cardUse({
					cardIds: this.cardids,
					cardCounts: arr2.join(),
					productType: this.productType,
					tradeno: this.movieItem.orderid,
					cityCode: this.movieItem.citycode,
					cinemaName: this.movieItem.cinemainfo.cinema_name,
					cinemaCode: this.movieItem.cinemainfo.cinema_code,
					cinemaId: this.movieItem.cinemainfo.cinemaid,
					area: this.movieItem.area,

					mobile: this.mobile,
				});

				this.useCard = res;
				this.useCard = res;
				this.useCard.wxPay = Math.round(this.useCard.wxPay * 100) / 100;
			}
		},
		async getCard() {
			const res = await cardList({
				mobile: this.mobile,
				pageIndex: 1,
				pageSize: 1000,
			});
			this.cardlists = res;
		},
		toSubmit() {
			this.cardWarnShow = false;
			this.payWarningShow = true;
		},
		// 检查是否有卡券
		async checkuseCard() {
			if (!this.cardids && this.cardlists.length > 0) {
				this.cardWarnShow = true;
			} else {
				this.cardWarnShow = false;
				// this.submit();
				this.payWarningShow = true;
			}
		},
		async checkPassword() {
			if (!this.passwordFlag) {
				this.passwordShow = true;
			} else {
				this.submit();
			}
		},
		passwordBackClick(bool) {
			this.passwordShow = false;
			this.passwordFlag = bool;
			if (bool) {
				this.submit();
			}
		},
		async submit() {
			if (this.stopData) {
				alert("请勿重复支付" + "___" + this.stopData);
				window.location = `${
					window.location.origin + "/shop"
				}/?t=${localStorage.getItem("t")}#/order?active=0`;
				return;
			}
			try {
				let moneyFlag =
					this.useCard !== ""
						? Math.round(this.useCard.wxPay * 100) / 100
						: Math.round(this.movieItem.totalPrice * 100) / 100;

				if (moneyFlag > 0) {
					if (!window.location.href.includes("tmall")) {
						let ua = navigator.userAgent.toLowerCase();
						let bool = /micromessenger/.test(ua) ? true : false;

						// if (!bool) {
						// 	return this.$toast("支付请在微信公众号中打开");
						// }
						if (
							JSON.parse(localStorage.getItem("mallInfo")).casepay &&
							JSON.parse(localStorage.getItem("mallInfo")).casepay != 1
						) {
							return this.$toast("商城只支持卡券抵扣,暂不支持其他支付");
						}
					}
				}

				this.overlayShow = true;
				let params = JSON.parse(JSON.stringify(this.movieItem));

				params.cardCounts = this.cardCounts;
				params.mallName = this.mallInfo.mallName;
				params.movieChannel = this.mallInfo.movieChannel;
				params.productType = this.productType;
				params.openid = this.userInfo.openid;
				params.smsMobile = this.mobile;
				params.cardIds = this.cardids;
				params.cinemaName = this.movieItem.cinemainfo.cinema_name;
				params.cinemaCode = this.movieItem.cinemainfo.cinema_code;
				params.tradeno = params.orderid;
				params.cinemaName = this.movieItem.cinemainfo.cinema_name;
				params.cinemaCode = this.movieItem.cinemainfo.cinema_code;
				params.cinemaId = this.movieItem.cinemainfo.cinemaid;
				params.cityCode = (this.currentCityCode + "")
					.split("")
					.splice(0, 4)
					.join("");
				params.mobile = this.userInfo.mobile;
				this.params = params;
				let res1 = await pay(params);
				this.stopData = JSON.stringify(res1);
				this.outTradeNo = res1.outTradeNo;
				this.unpayId = res1.unpayId;
				let res = res1.wxConfig;
				// this.checkPay();
				// if (!this.outTradeNo) {
				//   this.$toast("支付成功!");
				//   this.$router.push("/order?active=2");
				//   return;
				// }
				if (this.unpayId) {
					// this.checkPay();
				} else {
					alert("下单成功!");
					//	this.$toast("支付成功11!");
					window.location = `${
						window.location.origin + "/shop"
					}/?t=${localStorage.getItem("t")}#/order?active=0`;
					this.overlayShow = false;
					return;
				}

				if (typeof WeixinJSBridge == "undefined") {
					if (document.addEventListener) {
						document.addEventListener(
							"WeixinJSBridgeReady",
							this.onBridgeReady,
							false
						);
					} else if (document.attachEvent) {
						document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
						document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
					}
				} else {
					this.onBridgeReady(res);
				}
			} catch (err) {
				this.stopData = JSON.stringify(err);
			} finally {
				localStorage.removeItem("movieItem");
				this.overlayShow = false;
				this.subLoading = false;
			}
		},

		onBridgeReady(res) {
			//  let that = this;

			console.log("调用微信支付WeixinJSBridge");
			window.WeixinJSBridge.invoke(
				"getBrandWCPayRequest",
				{
					appId: res.appId, //公众号名称，由商户传入
					timeStamp: res.timeStamp, //时间戳，自1970年以来的秒数
					nonceStr: res.nonceStr, //随机串
					package: res.packageValue, //prepay_id = ?
					signType: res.signType, //微信签名方式：
					paySign: res.paySign, //微信签名
				},

				function (res) {
					// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
					if (res.err_msg == "get_brand_wcpay_request:ok") {
						//   vm.$message.success("支付成功") // 使用alert来弹窗 支付成功  是没有反应的。所以这里改为框架页面的弹窗就好了。注意必须要上这个微信浏览器内置事件外 转this指向才能弹窗
						//  vm.isDisabledSubmitBtn = false;
						alert("支付成功");
						// this.$router.push("/order?active=2");
						window.location = `${
							window.location.origin + "/shop"
						}/?t=${localStorage.getItem("t")}#/order?active=0`;
						this.overlayShow = false;
						// this.$toast.success("支付成功");

						// console.log("执行了我这个事件111111111");
					} else if (res.err_msg == "get_brand_wcpay_request:cancel") {
						alert("支付取消");
						// vm.isDisabledSubmitBtn = false;
						window.location = `${
							window.location.origin + "/shop"
						}/?t=${localStorage.getItem("t")}#/order?active=0`;
						//    this.$router.push("/order?active=1");
						//    this.$toast("支付取消");
						this.overlayShow = false;
						//  this.$router.push("/home");
					} else {
						alert("支付失败");
						window.location = `${
							window.location.origin + "/shop"
						}/?t=${localStorage.getItem("t")}#
						/order?active=0`;
						//    this.$router.push("/order?active=0");
						// console.log("执行了我这个事件3333333333");
						// this.$toast("付款失败");
						// alert("付款失败");
						//  this.$router.push("/home");
						this.overlayShow = false;
						// vm.isDisabledSubmitBtn = false;
					}
				}
			);
		},
		toCheckCard() {
			this.$goPage("checkCard", {
				price: this.$route.query.price,
				cardids: this.cardids,
				tradeno: this.orderInfo.tradeno,
				cityCode: this.orderInfo.citycode,
				spPrice: Math.round(this.orderInfo.showAmount * 100) / 100,
			});
		},
		// async pay(data) {
		//   const res = await pay(data);
		// },
	},
	beforeRouteEnter(to, from, next) {
		window.document.body.style.backgroundColor = "#eeeeee";

		next();
	},
	beforeRouteLeave(to, from, next) {
		window.document.body.style.backgroundColor = "#ffffff";
		next();
	},
};
</script>

<style lang="scss" scoped>
.filmOrder {
	font-size: 14px;
}
.settle-active {
	color: #909399 !important;
	text-decoration: line-through;
}
.fenge {
	background: #fff url("~@/assets/car-one.png");
	background-repeat: no-repeat;
	background-size: 100%;
	width: 100%;
	height: 3px;
}
::v-deep .van-field__control {
	font-size: 20px;
}
.img {
	width: 85px;
	height: 120px;
}
.sub-btn {
	background-color: #fff;
	position: fixed;
	bottom: 0;
	left: 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 100%;
}
.gpxz {
	background-color: #fff;
	padding: 10px;
	margin-bottom: 70px;
	.title {
		font-weight: 600;
		padding-bottom: 10px;
		border-bottom: 1px solid #eee;
	}
	.p {
		color: #626262;
		margin-bottom: 8px;
	}
}
</style>
